import { DrawerContainer } from '../../../../../../components/Drawer/DrawerContainer';
import { useGetCIIUCodesQuery } from '../../../../../../services/companyApi';
import { ContractorFormDrawer } from './ContractorFormDrawer';
import { ResponsibleFormDrawer } from './ResponsibleFormDrawer';

export const RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES = {
    NEW_CONTRACTOR: 'NEW_CONTRACTOR',
    EDIT_CONTRACTOR: 'EDIT_CONTRACTOR',
    NEW_RESPONSIBLE: 'NEW_RESPONSIBLE',
    EDIT_RESPONSIBLE: 'EDIT_RESPONSIBLE'
};

const DrawerManager = ({ open, setOpen, selected, contractorsState, responsiblesState, onlyVisual }: any) => {

    const handleCloseDrawer = () => {
        setOpen('');
    };

    const DrawerInputManager = () => {
        switch (open) {
            case RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.NEW_CONTRACTOR:
                return (
                    <ContractorFormDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selected={selected}
                        isEditing={false}
                        contractorsState={contractorsState}
                        onlyVisual={onlyVisual}
                    />
                );
            case RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.EDIT_CONTRACTOR:
                return (
                    <ContractorFormDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selected={selected}
                        isEditing={true}
                        contractorsState={contractorsState}
                        onlyVisual={onlyVisual}
                    />
                );
            case RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.NEW_RESPONSIBLE:
                return (
                    <ResponsibleFormDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selected={selected}
                        isEditing={false}
                        responsiblesState={responsiblesState}
                        onlyVisual={onlyVisual}
                    />
                );
            case RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.EDIT_RESPONSIBLE:
                return (
                    <ResponsibleFormDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selected={selected}
                        isEditing={true}
                        responsiblesState={responsiblesState}
                        onlyVisual={onlyVisual}
                    />
                );
            default:
                return <></>;
        }
    };

    return (
        <DrawerContainer setOpen={setOpen} open={open} customWidth={700}>
            <DrawerInputManager />
        </DrawerContainer>
    );
};

export default DrawerManager;
